import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { LicenseSelectingFunction } from '../licenseSelectingFunction';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { Localization } from '../../shared/enums/localization';
import { TokenService } from '../../shared/service/token.service';

@Component({
  selector: 'app-agree-license-modal',
  templateUrl: './agree-license-modal.html',
  styleUrls: ['./agree-license-modal.scss']
})
export class AgreeLicenseModalComponent implements OnInit {

  @ViewChild('modal') modal: ModalDirective;
  @Output() confirmed = new EventEmitter<any>();
  public content: string;
  public agreedToTerms: boolean;
  readonly Localization = Localization;

  constructor(private tokenService: TokenService) {
    this.content = '';
  }

  public getStartingLanguage() {
    return (this.tokenService.getCulture() != null) ? this.tokenService.getCulture() : navigator.language;
  }

  ngOnInit() {
    this.content = LicenseSelectingFunction(this.getStartingLanguage());
  }

  public onSubmit() {
    this.confirmed.emit();
  }

  public onAgreeToTermsChange(checked: boolean) {
    this.agreedToTerms = checked;
  }

  public show() {
    this.modal.show();
  }

  private isNotNullOrEmpty(value): boolean {
    return value != null && value !== '';
  }
}
